import { render, staticRenderFns } from "./RadioGroup.vue?vue&type=template&id=368b639f"
import script from "./RadioGroup.vue?vue&type=script&lang=ts"
export * from "./RadioGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports